module.exports = __webpack_public_path__ + "img/logo.6ded7360.png";